/* Quote capture UI and scheduled-hours status. No admin API, order or draft-order creation. */
(function () {
  'use strict';
  if (window.__amcLeadContactV1) return;
  window.__amcLeadContactV1 = true;
  var aliases = {
    'Organization': ['Organization', 'Company', 'Company name', 'organization'],
    'First name': ['First name', 'first_name'], 'Last name': ['Last name', 'last_name'],
    'phone': ['phone', 'Phone', 'Direct phone'], 'email': ['email', 'Email'],
    'Street address': ['Ship-to street', 'Street address', 'Address', 'address'],
    'City': ['Ship-to city', 'City', 'city'], 'State': ['Ship-to state', 'State', 'state'],
    'ZIP': ['Ship-to ZIP', 'Ship to', 'ZIP', 'zip'], 'Additional questions': ['Additional questions']
  };
  function field(form, name) {
    return Array.from(form.elements).find(function (el) { return el.name === 'contact[' + name + ']'; });
  }
  function syncName(form) {
    var first = field(form, 'First name'), last = field(form, 'Last name'), full = field(form, 'name');
    if (first && last && full) full.value = (first.value.trim() + ' ' + last.value.trim()).trim();
  }
  function enhance(form) {
    if (form.dataset.amcLeadReady || form.querySelector('[name="form_type"][value="customer"]')) return;
    var context = form.id + ' ' + location.pathname + ' ' + (form.closest('[data-amc-desk]')?.dataset.amcDesk || '');
    if (!/quote|rfq|amcpoform|amc-desk-form-po/i.test(context)) return;
    if (!form.querySelector('[name="form_type"][value="contact"]')) return;
    var template = document.getElementById('AmcQuoteLeadFields');
    if (!template) return;
    form.dataset.amcLeadReady = '1';
    var fields = template.content.firstElementChild.cloneNode(true);
    var full = field(form, 'name'), priorName = full ? full.value.trim().split(/\s+/) : [];
    if (full) {
      var fullLabel = full.closest('label');
      full.type = 'hidden'; full.required = false; form.appendChild(full);
      if (fullLabel && !fullLabel.querySelector('input,select,textarea')) fullLabel.remove();
    } else {
      full = document.createElement('input'); full.type = 'hidden'; full.name = 'contact[name]'; form.appendChild(full);
    }
    Object.keys(aliases).forEach(function (key) {
      var replacement = Array.from(fields.querySelectorAll('[name]')).find(function (el) { return el.name === 'contact[' + key + ']'; });
      var names = aliases[key];
      if (key === 'Additional questions' && form.id === 'AmcQuoteForm') names = names.concat('body');
      if (key === 'Additional questions' && form.id === 'AmcPoForm') names = names.concat('Notes');
      var existing = names.map(function (name) { return field(form, name); }).find(Boolean);
      if (existing) {
        var label = existing.closest('label');
        existing.required = key !== 'Additional questions';
        if (replacement.autocomplete) existing.autocomplete = replacement.autocomplete;
        replacement.replaceWith(existing);
        if (label && !label.querySelector('input,select,textarea,button')) label.remove();
      } else if (key === 'First name') replacement.value = priorName.shift() || '';
      else if (key === 'Last name') replacement.value = priorName.join(' ');
    });
    var anchor = form.querySelector('label,.amc-qb__two,.amc-po__two,.amc-desk__fields,button[type="submit"]');
    var mode = form.querySelector('.amc-po__mode');
    if (mode) mode.after(fields);
    else if (anchor) {
      var top = anchor;
      while (top.parentElement !== form && top.parentElement) top = top.parentElement;
      form.insertBefore(fields, top);
    } else form.appendChild(fields);
    var procurementTemplate = document.getElementById('AmcProcurementFields');
    if (procurementTemplate && !form.querySelector('.amc-procurement')) {
      var procurement = procurementTemplate.content.firstElementChild.cloneNode(true);
      if (field(form, 'PO number')) procurement.querySelector('[data-po-reference-field]').remove();
      fields.after(procurement);
    }
    form.querySelectorAll('.amc-qb__two,.amc-po__two,.amc-po__three,.amc-desk__fields').forEach(function (row) {
      if (!row.querySelector('input,select,textarea,button')) row.remove();
    });
    if (form.id === 'AmcPoForm') form.querySelectorAll('h3').forEach(function (h) {
      if (/^ship-to address$/i.test(h.textContent.trim())) h.remove();
    });
    form.querySelectorAll('input,textarea').forEach(function (input) {
      input.addEventListener('input', function () { syncName(form); });
    });
    syncName(form);
  }
  function statusAt(date) {
    var p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(date);
    function value(k) { return p.find(function (x) { return x.type === k; }).value; }
    var minute = Number(value('hour')) * 60 + Number(value('minute'));
    if (/Sat|Sun/.test(value('weekday')) || minute < 540 || minute >= 1020) return { state: 'closed', label: 'Closed' };
    return minute >= 990 ? { state: 'soon', label: 'Closing soon' } : { state: 'open', label: 'Open now' };
  }
  window.AMCBusinessHours = { statusAt: statusAt, timeZone: 'America/New_York' };
  function updateHours() {
    var state = statusAt(new Date());
    document.querySelectorAll('[data-amc-support-status]').forEach(function (el) {
      if (el.dataset.state !== state.state || el.textContent !== state.label) { el.dataset.state = state.state; el.textContent = state.label; }
    });
  }
  function buyerBar() {
    if (/^\/cart(?:\/|$)/.test(location.pathname) || document.getElementById('AmcBuyerBar')) return;
    var nav = document.createElement('nav');
    nav.id = 'AmcBuyerBar'; nav.className = 'amc-buyer-bar'; nav.setAttribute('aria-label', 'Buying options'); nav.hidden = true;
    nav.innerHTML = '<button type="button" data-amc-qpill>Quote <span data-amc-qpill-n hidden></span></button>' +
      '<a href="/pages/financing" data-amc-finpill>Financing</a>' +
      '<button type="button" data-amc-popill>PO / RFQ <span data-amc-popill-n hidden></span></button>';
    document.body.appendChild(nav);
    var queued = false, threshold = 0;
    function measure() {
      var hero = document.querySelector('body.index-template .amc-opening-hero');
      var header = document.querySelector('.amc-hdr');
      threshold = Math.max(innerHeight * 0.25, hero ? hero.getBoundingClientRect().bottom + scrollY : (header ? header.offsetHeight + 48 : 180));
      update();
    }
    function update() {
      queued = false;
      var reveal = scrollY >= threshold;
      if (reveal === (nav.dataset.revealed === 'true')) return;
      nav.dataset.revealed = String(reveal); nav.hidden = !reveal;
      document.documentElement.classList.toggle('amc-has-buyer-bar', reveal);
      if (!reveal) nav.querySelectorAll('[aria-expanded="true"]').forEach(function (button) {
        button.click();
      });
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', measure, { passive: true });
    addEventListener('pageshow', measure);
    var hero = document.querySelector('body.index-template .amc-opening-hero');
    if (hero && window.ResizeObserver) new ResizeObserver(measure).observe(hero);
    measure();
  }
  function previewOffset() {
    var wrapper = document.getElementById('PBarNextFrameWrapper');
    var rect = wrapper && wrapper.getBoundingClientRect();
    var offset = rect && rect.height > 0 && rect.top < innerHeight ? Math.max(0, innerHeight - rect.top) : 0;
    document.documentElement.style.setProperty('--amc-preview-offset', offset + 'px');
    if (wrapper && !wrapper.__amcObserved && window.ResizeObserver) {
      wrapper.__amcObserved = true;
      new ResizeObserver(previewOffset).observe(wrapper);
    }
  }
  function boot() { buyerBar(); document.querySelectorAll('form[action*="/contact"]').forEach(enhance); updateHours(); previewOffset(); }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.dataset.amcLeadReady) return;
    syncName(form);
    if (!form.checkValidity()) { event.preventDefault(); event.stopImmediatePropagation(); form.reportValidity(); }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  addEventListener('resize', previewOffset, { passive: true });
  setInterval(updateHours, 30000);
  new MutationObserver(function (records) {
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
      return n.nodeType === 1 && (n.matches('[data-amc-contact-strip]') || n.querySelector('[data-amc-contact-strip]'));
    }); })) updateHours();
    if (records.some(function (r) { return Array.from(r.addedNodes).some(function (n) {
      return n.nodeType === 1 && (n.id === 'PBarNextFrameWrapper' || n.querySelector('#PBarNextFrameWrapper'));
    }); })) previewOffset();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
